import React from "react";
import {connect} from "react-redux";
import locale from "../../locale";
import onBannerClick from "../../actions/onBannerClick";

class LayoutExpositionLinks extends React.Component
{
	onBannerClick(banner)
	{
		const {event} = this.props;

		if (!banner.trackingKey) {
			return;
		}

		onBannerClick(event.id, banner.trackingKey);
	}

	render()
	{
		const {settings} = this.props;

		return (
			<aside className="section-exposition" id="exposition-links" style={settings.style}>
				<div className="landing-nav-section-text">
					{settings.links.map((props, index) =>
						<article className="exposition-brand-link" key={index}>
							<a href={props.link} target="_blank"
								onClick={() => this.onBannerClick(props)}
								style={{backgroundImage: `url(${props.logoUrl})`}}
								title={locale.getProperty(props, 'name')}
							/>
						</article>
					)}
				</div>
			</aside>
		);
	}
}

const mapStateToProps = (store) => ({
	event: store.event,
});

export default connect(mapStateToProps)(LayoutExpositionLinks);
